module.exports = __webpack_public_path__ + "img/john-harald-knutsson-l.5baf2dde.webp";